import { render, staticRenderFns } from "./Directory.vue?vue&type=template&id=d36c1a80&scoped=true&"
import script from "./Directory.vue?vue&type=script&lang=js&"
export * from "./Directory.vue?vue&type=script&lang=js&"
import style0 from "./Directory.vue?vue&type=style&index=0&id=d36c1a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36c1a80",
  null
  
)

export default component.exports